import { NetSuiteGetSubsidiariesResponse, NetSuiteGetSubsidiariesResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { useCanConnectNetSuite } from '..';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';

export function useNetSuiteSubsidiaries(options?: CustomUseQueryOptions<NetSuiteGetSubsidiariesResponse>) {
  const isNetSuiteEnabled = useCanConnectNetSuite();

  return useQuery(
    queryKeys.netSuiteSubsidiaries(),
    async () => {
      const api = getPrivateApi();
      const netSuiteSubsidiaries = await api.getNetSuiteSubsidiaries();

      return NetSuiteGetSubsidiariesResponseSchema.parse(netSuiteSubsidiaries);
    },
    {
      enabled: isNetSuiteEnabled,
      ...options,
    },
  );
}
